import type { AnyObject, Result, ResultStatus, ResultType } from '@netpurpose/types'

type BackendResult = {
  status: ResultStatus
  type: ResultType
  data: string | null | AnyObject
}

export const parseResult = <T>(result: BackendResult): Result<T> => ({
  status: result.status,
  type: result.type,
  ...(result.data !== null ? { data: result.data as T } : {}),
})
